import { useSelector } from 'react-redux'

import { EnterDetailsFieldset } from 'components/enter_details/form_field_spacing'

import { inviteeNameFormatSelector } from '../../../../../selectors'

import CombinedNameInput from './combined_name_input'
import EmailInput from './email_input'
import SeparatedNameInput from './seperated_name_input'

const InviteeInputs = ({ inviteeName, onInviteeNameChange, inviteeEmail, onInviteEmailChange }) => {
  const inviteeNameFormat = useSelector(inviteeNameFormatSelector)

  const renderNameInput = () => (inviteeNameFormat === 'combined'
    ? (
      <CombinedNameInput
        fullName={inviteeName.full_name}
        onChange={onInviteeNameChange}
      />
    ) : (
      <SeparatedNameInput
        firstName={inviteeName.first_name}
        lastName={inviteeName.last_name}
        onChange={onInviteeNameChange}
      />
    ))
  return (
    <EnterDetailsFieldset>
      {renderNameInput()}
      <EmailInput
        email={inviteeEmail}
        onChange={onInviteEmailChange}
      />

    </EnterDetailsFieldset>
  )
}

export default InviteeInputs
